import { render, staticRenderFns } from "./PageAppFeedback.vue?vue&type=template&id=f8b81fd8&"
import script from "./PageAppFeedback.vue?vue&type=script&lang=js&"
export * from "./PageAppFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports